export default __webpack_public_path__ + "static/media/6.7b620491.jpg";